<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-if="activeName == '1'">
			<div class="center_filter">
			</div>
			<div class="center_tables center_coursenote clearfix">
				<emptymain :emptytext="'暂无消息'" :emptylist='noticeList'></emptymain>
				<div class="center_message" v-for="item in noticeList">
					<div class="center_messageTitle text-ellipsis">
						<el-tag type='danger' v-if="item.isRead == '0'">未读</el-tag>
						<el-tag type='info' v-if="item.isRead == '1'">已读</el-tag>
						<span>{{item.title}}</span>
						<div class="center_messageIn" @click="toDetails(item)">查看详情</div>
					</div>
					<div class="center_messageDesc text-ellipsis">
						<span>{{item.description}}</span>
						<div class="center_messageTime">
							{{item.releaseTime}}
						</div>
					</div>
				</div>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="handleCurrentChange" :current-page="current" :page-size="limit" layout="total,  prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>
		<div v-if="activeName == '2'">
			<div class="center_filter">
			</div>
			<div class="center_tables center_coursenote clearfix">
				<emptymain :emptytext="'暂无申诉反馈'" :emptylist='repreList'></emptymain>
				<div class="center_message" v-for="item in repreList">
					<div class="center_messageTitle text-ellipsis">
						<el-tag type='info' v-if="item.examineStatus == '0'">未回复</el-tag>
						<el-tag type='success' v-if="item.examineStatus == '1'">已回复</el-tag>
						<span class="center_messageTitleSpan">考试名称：{{item.examineName}}</span>
						<div class="center_messageIn" @click="openView(item)">查看详情</div>
					</div>
					<div class="center_messageDesc text-ellipsis">
						<span>{{item.representation}}</span>
						<div class="center_messageTime">
							{{item.createTime}}
						</div>
					</div>
				</div>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="currentReChange" :current-page="currentRe" :page-size="limit" layout="total,  prev, pager, next" :total="totalRe">
				</el-pagination>
			</div>
		</div>
		<el-dialog :title="detailInfo.title || '消息详情'" class="open_dialogInfo" :visible.sync="infoOpen" :append-to-body='true' width="700px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<div class="dialog_message dialog_messageText beautifulScroll">
				<div v-html='detailInfo.context'></div>
			</div>
		</el-dialog>
		<el-dialog title="申诉详情" class="open_dialogInfo" :visible.sync="viewDialog" :append-to-body='true' width="500px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<div class="dialog_message beautifulScroll">
				<div class="center_filterInput">
					<el-form label-width="100px">
						<el-form-item label="申诉时间：">
							<div class="feedback_text">
								{{viewInfo.createTime}}
							</div>
						</el-form-item>
						<el-form-item label="申诉内容：">
							<div class="feedback_textare">
								<textarea v-model='viewInfo.representation' readonly="readonly" placeholder="您的意见或建议"></textarea>
							</div>
						</el-form-item>
						<el-form-item label="回复内容：">
							<div class="feedback_textare">
								<textarea v-model='viewInfo.representationReply' readonly="readonly"></textarea>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { noticeList, userIsRead } from '@/api/notice.js'
	import { getMyRepresentation } from '@/api/examine.js'
	import { spliceForTask } from '@/filters/index.js'
	export default {
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '校内公告',
					id: '1'
				}, {
					name: '考试申诉',
					id: '2'
				}],
				limit: 10,
				current: 1,
				total: 0,
				noticeList: [],
				infoOpen: false,
				detailInfo: {},
				//申诉
				repreList: [],
				currentRe: 1,
				totalRe: 0,
				viewDialog: false,
				viewInfo: {},
			};
		},
		created() {
			this.getNotice();
			this.getMyRepresentation();
		},
		methods: {
			openView(item) {
				this.viewInfo = item;
				this.viewInfo.createTime = spliceForTask(item.createTime)
				this.viewDialog = true;
			},
			currentReChange(currentRe) {
				this.currentRe = currentRe;
				this.getMyRepresentation();
			},
			getMyRepresentation() {
				var data = {
					limit: this.limit,
					current: this.currentRe,
				}
				getMyRepresentation(data).then(res => {
					if(res.code == "OK") {
						this.repreList = res.data.records;
						this.totalRe = res.data.total;
					}
				})
			},
			toDetails(item) {
				userIsRead({
					notice_id: item.id
				});
				this.detailInfo = Object.assign({}, item),
					this.infoOpen = true;
			},
			handleCurrentChange(current) {
				this.current = current;
				this.getNotice()
			},
			getNotice() {
				noticeList({
					current: this.current,
					limit: this.limit,
					state: 1
				}).then(res => {
					this.noticeList = res.data.records;
					this.total = res.data.total;
				})
			},
		}
	}
</script>